import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';
import { NgClass } from '@angular/common';
import { SentenceCasePipe } from '../../pipes/sentence.pipe';

/**
 * @deprecated Do not add new instances of this component. Use PrimeNG's 'p-tabs' instead.
 */
@Component({
  selector: 'ag1-tab',
  templateUrl: './ag1-tab.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass, SentenceCasePipe],
})
export class Ag1TabComponent {
  scrolledIntoView = 0;

  @Input()
  tabs: string[] = [];
  @Input()
  disabledTabs: string[] = [];
  @Input()
  activeTab: string = this.tabs[0];
  @Input()
  customStyle: string;
  @Input()
  loading: boolean = false;
  @Input()
  set scrollIntoView(scrollIntoView: number) {
    // support to allow scrolling selected tab into view (e.g. after we know a tab has been set programmatically)
    if (this.scrolledIntoView < scrollIntoView) {
      this.scrolledIntoView = scrollIntoView;
      setTimeout(() => {
        const ele = document.getElementsByClassName('ag1-tab--active')[0];
        if (ele) {
          ele.scrollIntoView({ block: 'nearest', inline: 'center' });
        }
      }, 0);
    }
  }
  @Input()
  classOverrides: string = '';

  @Output()
  activeTabChange = new EventEmitter<string>();

  onTabChanges(tab: string): void {
    this.activeTab = tab;
    this.activeTabChange.emit(this.activeTab);
  }
}
